import React, { Component, useMemo } from 'react';
import Table from "../../../../../components/UI/Table/Table";
import { Row } from 'reactstrap';


class ViewNewsCases extends Component {

    tableColumns = [
        {
            Header: (
                <input
                  type="checkbox"
                  style ={{ width: "50px" , height: "20px"}}
                  onClick={(e) => this.props.handleSelectAllChange()}
                  checked={this.props.selectAll}
                  onChange={e => {}}
                />
              ),
            id: 'invalid',
            Cell: (p) => <label>
                <input id={p} type="checkbox" style ={{ width: "50px" , height: "20px"}} checked={p.original.newsInvalid || false} 
                    onClick={(e) => this.props.handleOnChange("checkbox",e.target.checked, p.index)} />
                </label>
        },
        {
            Header: 'Date',
            id: 'date',
            accessor: 'date'
        },
        {
            Header: "Title",
            id: 'newsTitle',
            accessor: 'newsTitle'
        },
        {
            Header: 'Sentiment',
            id: 'newsSentiment',
            Cell: (p) => <select className="form-control d-flex justify-content-between align-items-center px-3 w-100" style={{fontSize: '0.9rem'}} id="sel1" value={p.original.newsSentiment} onChange={(e) => this.props.handleOnChange("sentiment",e.target.value, p.index)} >
                {<option value={p.original.newsSentiment} className="px-3" disabled>{p.original.newsSentiment}</option>}
                {p.original.newsSentiment.toLowerCase() !== 'positive' && (<option value="Positive" className="px-3">Positive</option>)}
                {p.original.newsSentiment.toLowerCase() !== 'negative' && (<option value="Negative" className="px-3">Negative</option>)}
                {p.original.newsSentiment.toLowerCase() !== 'neutral' && ( <option value="Neutral" className="px-3">Neutral</option>)}
            </select>
        },
        {
            Header: 'Link',
            id: 'newsLink',
            accessor: p => <a href={p.newsLink} target="_blank" rel="noreferrer" > Click </a>
        }
    ];

    render() {
        return (
            <Table
                data={this.props.tasks}
                columns={this.tableColumns}
                defaultPageSize={10}
                className="CreateCaseModalTable highlight"
                showPagination={true}
                showPaginationTop={false}
                showPaginationBottom={true}
                noDataText="No Cases found"
            />
        )
    }
}

export default ViewNewsCases;
